import React from 'react';
import { styled } from '@components-shared/src/stitches';
import type { TopChartsType } from '@pages-shared/topCharts';
import type { ViralChartsType } from '@pages-shared/viralCharts';
import type { ChartProps, ChartTabsType } from '../ChartTabs';
import { ChartTabs } from '../ChartTabs';
import { ChartContentTabs } from '../ContentTabs';

interface ChartTopProps extends ChartProps {
  onChartTypeSelection: (value: ChartTabsType) => void;
  onChartContentSelection: ((value: TopChartsType) => void) | ((value: ViralChartsType) => void);
  icons: JSX.Element;
  disableChartTabs?: boolean;
  loading?: boolean;
}

export function ChartTop({
  chartType,
  contentType,
  onChartContentSelection,
  onChartTypeSelection,
  disableChartTabs = false,
  loading,
  icons,
}: ChartTopProps) {
  return (
    <Container>
      {!disableChartTabs && (
        <ChartTabs
          value={chartType}
          onSelection={onChartTypeSelection}
          loading={loading}
          icons={icons}
        />
      )}
      <ContentContainer>
        <ChartContentTabs
          selected={contentType}
          onSelection={onChartContentSelection}
          loading={loading}
          chartType={chartType}
        />
      </ContentContainer>
    </Container>
  );
}

const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

const ContentContainer = styled('div', {
  marginTop: 8,
});
